var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","id":"contrato-emporio-app-site","hide-footer":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('iframe',{attrs:{"src":"https://construp-imagens.s3.us-east-2.amazonaws.com/pdf/FICHA+CADASTRAL+JOBER+FORNEC+NOVA.pdf","width":"100%","height":"700px"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }